
const links = document.querySelectorAll('a[href^="#"]:not([js-menu-link])');
let sectionOffset = 60;

if (window.innerWidth >= 1280) {
    sectionOffset = 80;
}

for (const link of links) {
    link.addEventListener("click", clickHandler);
}


function clickHandler(e) {
    e.preventDefault();
    const href = this.getAttribute("href");
    let offsetTop;

    if(href === "#main-content") {
        offsetTop = document.querySelector(href).getBoundingClientRect().top + window.scrollY;
    } else {
        offsetTop = document.querySelector(href).getBoundingClientRect().top + window.scrollY - sectionOffset;
    }

    scroll({
        top: offsetTop,
        behavior: "smooth"
    });
}
